<template>
  <div class="all">
    <div class="register-bar">
      <img alt="" :src="IMG_SRC.rightArrow" class="public-goback-img" @click="goBack" />
      <div class="public-goback-return" @click="goBack">返回</div>
    </div>
    <div class="message-wrap">
      <el-alert v-if="!!error && !enterpriseInfo" title="信息填写不完整或错误" type="error" />
      <div v-if="!!enterpriseInfo && enterpriseInfo.status === 'SUBMIT'" class="submit-message">
        <div class="box">
          <img alt="" :src="IMG_SRC.roundSelected" class="img" />
        </div>
        <div class="title">
          您的信息已上传，预计1个工作日内完成审核，请届时留意您的联系邮箱和手机来电
        </div>
      </div>
      <div
        v-if="!!enterpriseInfo && enterpriseInfo.status === 'REJECTED'"
        class="rejected-message-failure"
      >
        <div class="box">
          <img alt="" :src="IMG_SRC.roundUnSelected" class="img" />
        </div>
        <div class="title">
          您提交的申请未能通过审核，请核对后，将企业信息和证照照片及联系电话发送到TSEP_eyao@tencent.com。管理员审核后，将通过审核与您联系
        </div>
      </div>
      <!-- <div   v-if="!!enterpriseInfo && enterpriseInfo.status === 'SUBMIT'" class="submit-data">
                    <div class="box">
                        <img :src="IMG_SRC.roundUnSelected" class="img">
                    </div>
                    <div class="title">
                        提交失败
                    </div>
                </div> -->
    </div>
    <div class="schedule-box">
      <div class="schedule-Article">
        <div :class="stepClass.bind(this, 1, 'one')()">
          <div class="number">01</div>
          <div class="title">填写账号信息</div>
          <img alt="" :src="IMG_SRC.line" class="img" />
        </div>
        <div :class="stepClass.bind(this, 2, 'two')()">
          <div class="number">02</div>
          <div class="title">证件上传</div>
          <img v-if="activeStep >= 2" alt="" :src="IMG_SRC.line" class="img" />
          <img v-else alt="" :src="IMG_SRC.blockLine" class="img" />
        </div>
        <div :class="stepClass.bind(this, 3, 'three')()">
          <div class="number">03</div>
          <div class="title">等待审核</div>
          <img v-if="activeStep >= 3" alt="" :src="IMG_SRC.line" class="img" />
          <img v-else alt="" :src="IMG_SRC.blockLine" class="img" />
        </div>
        <div :class="stepClass.bind(this, 4, 'four')()">
          <div class="number">04</div>
          <div class="title">审核结果</div>
        </div>
      </div>
    </div>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col class="register-inner">
        <div v-if="!!enterpriseInfo" class="step-3 Review">
          <div class="input">审核信息</div>
          <el-form ref="form" label-width="150px" label-suffix=":" size="medium">
            <el-form-item class="show" label="企业名称">
              <span class="form-span">{{ enterpriseInfo.enterprise_name }}</span>
            </el-form-item>
            <el-form-item class="show" label="企业类型">
              <span class="form-span">{{ enterpriseTypeName }}</span>
            </el-form-item>
            <el-form-item class="show" label="所在地址">
              <span class="form-span">{{ enterpriseInfo.address }}</span>
            </el-form-item>
            <el-form-item class="show" label="人员规模">
              <span class="form-span">{{ userSizeName }}</span>
            </el-form-item>
            <el-form-item class="show" label="管理员姓名">
              <span class="form-span">{{ enterpriseInfo.contact_name }}</span>
            </el-form-item>
            <el-form-item class="show" label="所在部门">
              <span class="form-span">{{ enterpriseInfo.department_name }}</span>
            </el-form-item>
            <el-form-item class="show" label="联系邮箱">
              <span class="form-span">{{ enterpriseInfo.contact_email }}</span>
            </el-form-item>
            <el-form-item class="show id-card" label="运营者身份证">
              <el-row>
                <el-col class="image-wrap-positive">
                  <img alt="身份证正面" :src="enterpriseInfo.id_card_no_url" class="id-positive" />
                  <br />
                  <span class="demonstration">正面</span>
                </el-col>
                <el-col class="image-wrap-anti">
                  <img alt="身份证反面" :src="enterpriseInfo.id_card_no_url_b" class="id-anti" />
                  <br />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item class="show" label="营业执照">
              <el-row>
                <el-col class="image-wrap-Business">
                  <img alt="营业执照" :src="enterpriseInfo.licence_url" class="Business-img" />
                  <br />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item class="show" label="授权公函">
              <el-row>
                <el-col class="Official">
                  <img alt="授权公函" :src="enterpriseInfo.authrization_url" class="id-Official" />
                  <br />
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="!enterpriseInfo" class="fill-information">
          <el-form
            ref="formData"
            :model="formData"
            label-width="150px"
            label-suffix=":"
            size="medium"
            :rules="rules"
            class="fill-form"
          >
            <div v-show="formData.step === 1" class="step1">
              <div class="input">填写账号信息</div>
              <el-form-item label="企业名称" prop="enterprise_name" class="enterprise-name">
                <el-input
                  v-model="formData.enterprise_name"
                  placeholder="请输入企业名称"
                  class="register enterprise-name-input"
                  :maxlength="30"
                  clearable
                />
              </el-form-item>
              <el-form-item label="企业类型" prop="enterprise_type" class="enterprise-type">
                <el-radio-group v-model="formData.enterprise_type">
                  <el-radio
                    v-for="item in enterpriseType"
                    :key="item.value"
                    :label="item.value"
                    class="enterprise-type-radio"
                  >
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="所在地区" prop="cityProvince" class="resource cascader-province">
                <div class="Province">省:</div>
                <el-select
                  v-model="formData.account_province"
                  placeholder="请选择"
                  :clearable="true"
                  class="accountProvince"
                  @change="citychang"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.id"
                    :label="item.provinceName"
                    :value="item.provinceCode"
                  />
                </el-select>
                <div class="city">市：</div>
                <el-select
                  v-model="formData.city_province"
                  placeholder="请选择"
                  :clearable="true"
                  class="accountProvince"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.cityName"
                    :value="item.cityCode"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="详细地址" prop="address" class="address">
                <el-input
                  v-model="formData.address"
                  placeholder="请输入详细地址信息，如道路、门牌号、楼栋号、单元等信息"
                  class="enterprise-name-input enterprise-name-input"
                  clearable
                  :maxlength="50"
                />
              </el-form-item>
              <el-form-item label="人员规模" prop="user_size" class="user_size">
                <el-radio-group v-model="formData.user_size">
                  <el-radio
                    v-for="item in userSize"
                    :key="item.value"
                    :label="item.value"
                    class="user_size-radio"
                  >
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="管理员姓名" prop="contact_name" class="contact_name">
                <el-input
                  v-model="formData.contact_name"
                  placeholder="请输入管理员姓名"
                  class="contact_name-input"
                  :maxlength="10"
                  clearable
                />
              </el-form-item>
              <el-form-item label="所在部门" prop="department_name" class="contact_name">
                <el-input
                  v-model="formData.department_name"
                  placeholder="请输入所在部门"
                  class="contact_name-input"
                  :maxlength="20"
                  clearable
                />
              </el-form-item>
              <el-form-item label="联系邮箱" prop="contact_email" class="contact_name">
                <el-input
                  v-model="formData.contact_email"
                  placeholder="请输入联系邮箱"
                  class="contact_name-input"
                  clearable
                  :maxlength="50"
                />
              </el-form-item>
              <el-form-item label="" prop="agreement" class="agreement">
                <el-checkbox v-model="formData.agreement" class="agreement-checkbox">
                  我同意并遵守
                  <router-link target="_blank" :to="{ path: '/p/protocol' }" class="span">
                    《腾讯智慧医药管理平台服务协议》
                  </router-link>
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button class="information-save" @click="saveDraft">保存</el-button>
                <el-button type="primary" @click="goNext" class="information-next">
                  下一步
                </el-button>
              </el-form-item>
            </div>

            <div v-show="formData.step !== 1" class="step2">
              <div class="input updata">证件上传</div>
              <el-form-item label="运营者身份证" prop="id_card_no_url" class="id_card">
                <el-row>
                  <el-col class="image-wrap image-wrap-id-card">
                    <el-progress :percentage="0" />
                    <el-upload
                      :on-error="handleAvatarError.bind(this, 'id_card_no_url')"
                      :headers="getHeaders"
                      :action="uploadUrl"
                      :multiple="false"
                      list-type="picture-card"
                      :file-list="id_card_no_url_file_list"
                      :show-file-list="true"
                      :on-success="handleAvatarSuccess.bind(this, 'id_card_no_url')"
                      :on-remove="handleAvatarRemovePositive.bind(this, 'id_card_no_url')"
                      :before-upload="beforeAvatarUpload.bind(this, 'id_card_no_url')"
                      :class="{ hide: hideUpload }"
                      :limit="1"
                    >
                      <i
                        v-if="!formData.id_card_no_url"
                        class="el-icon-plus avatar-uploader-icon"
                        @click="selectImg"
                      />
                    </el-upload>
                    <div class="title">文件大小需小于2M，且格式为png、jpg</div>
                  </el-col>
                  <el-col class="image-wrap-Negative">
                    <el-upload
                      :on-error="handleAvatarError.bind(this, 'id_card_no_url_b')"
                      :headers="getHeaders"
                      :action="uploadUrl"
                      :multiple="false"
                      list-type="picture-card"
                      :file-list="id_card_no_url_b_file_list"
                      class="uploader"
                      :show-file-list="true"
                      :on-success="handleAvatarSuccess.bind(this, 'id_card_no_url_b')"
                      :on-remove="handleAvatarRemoveAnti.bind(this, 'id_card_no_url_b')"
                      :before-upload="beforeAvatarUpload.bind(this, 'id_card_no_url_b')"
                      :on-change="dealImgChangeAnti"
                      :class="{ hide: hideUploadAnti }"
                      :limit="1"
                    >
                      <i
                        v-if="!formData.id_card_no_url_b"
                        class="el-icon-plus avatar-uploader-icon"
                        @click="selectImg"
                      />
                    </el-upload>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="营业执照" prop="licence_url" class="id-license">
                <el-row>
                  <el-col class="image-wrap-license">
                    <el-upload
                      :on-error="handleAvatarError.bind(this, 'licence_url')"
                      :headers="getHeaders"
                      :action="uploadUrl"
                      :multiple="false"
                      list-type="picture-card"
                      :file-list="licence_url_file_list"
                      class="uploader"
                      :show-file-list="true"
                      :on-success="handleAvatarSuccess.bind(this, 'licence_url')"
                      :on-remove="handleAvatarRemoveLicense.bind(this, 'licence_url')"
                      :before-upload="beforeAvatarUpload.bind(this, 'licence_url')"
                      :on-change="Licensechange"
                      :class="{ hide: licenseHide }"
                      :limit="1"
                    >
                      <i
                        v-if="!formData.licence_url"
                        class="el-icon-plus avatar-uploader-icon"
                        @click="selectImg"
                      />
                    </el-upload>
                    <div class="title" @click="selectImg">文件大小需小于2M，且格式为png、jpg</div>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="授权公函" prop="authrization_url" class="authrization">
                <el-row>
                  <el-col class="authrization-url">
                    <el-upload
                      :on-error="handleAvatarError.bind(this, 'authrization_url')"
                      :headers="getHeaders"
                      :action="uploadUrl"
                      :multiple="false"
                      list-type="picture-card"
                      :file-list="authrization_url_file_list"
                      class="uploader"
                      :show-file-list="true"
                      :on-success="handleAvatarSuccess.bind(this, 'authrization_url')"
                      :on-remove="handleAvatarRemoveOfficial.bind(this, 'authrization_url')"
                      :before-upload="beforeAvatarUpload.bind(this, 'authrization_url')"
                      :on-change="Officialchange"
                      :class="{ hide: officialHide }"
                      :limit="1"
                    >
                      <i
                        v-if="!formData.authrization_url"
                        class="el-icon-plus avatar-uploader-icon"
                        @click="selectImg"
                      />
                    </el-upload>
                    <div class="title">文件大小需小于2M，且格式为png、jpg</div>
                    <div class="Comment">
                      注：点击下载
                      <a class="down" @click="downOfficial">授权公函</a>
                      ，盖章后上传公函照片
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item class="botton">
                <el-button class="id-prev" @click="goPrev">上一步</el-button>
                <el-button class="id-save" @click="saveDraft">保存</el-button>
                <el-button type="primary" @click="doSubmit('formData')" class="id-Submit">
                  提交
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  saveDrafts,
  selectOptions,
  getDrafts,
  registerEnterprises,
  getEnterpriseByManagers,
} from '@/api/register.js';
import { IMG_SRC } from '@/utils/constant.js';

export default {
  components: {},

  data() {
    return {
      IMG_SRC,
      error: null,
      src: IMG_SRC.exampleImg,
      enterpriseInfo: null,
      step_active: 1,
      enterpriseType: [],
      userSize: [],
      rules_step1: {
        enterprise_name: [{ required: true, message: '请输入企业名称', trigger: 'change' }],
        enterprise_type: [{ required: true, message: '请选择企业类型', trigger: 'change' }],
        city_province: [{ required: true, message: '请选择所在区域', trigger: 'change' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'change' }],
        user_size: [{ required: true, message: '请选择人员规模', trigger: 'change' }],
        contact_name: [{ required: true, message: '请输入管理员姓名', trigger: 'change' }],
        department_name: [{ required: true, message: '请输入所在部门', trigger: 'change' }],
        contact_email: [
          { required: true, message: '请输入联系邮箱', trigger: 'change' },
          {
            type: 'email',
            message: '请输入正确的联系邮箱',
            trigger: ['blur', 'change'],
          },
        ],
      },
      rules_step2: {
        licence_url: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
        id_card_no_url_b: [
          {
            required: true,
            message: '请上传运营者身份证 -- 国徽面',
            trigger: 'change',
          },
        ],
        id_card_no_url: [{ required: true, message: '请上传运营者身份证', trigger: 'change' }],
        authrization_url: [{ required: true, message: '请上传授权函地址', trigger: 'change' }],
      },
      formData: {
        step: 1,
        agreement: false, // 平台法律同意条款
        enterprise_name: null, // 企业名称
        enterprise_type: null, // 企业类型
        address: null, // 详细地址
        user_size: null, // 人员规模
        contact_name: null, // 管理员姓名
        department_name: null, // 所在部门，
        contact_email: null, // 联系邮箱
        licence_url: null, // 营业执照地址
        id_card_no_url_b: null, // 身份证照片 -- 国徽面
        id_card_no_url: null, // 身份证照片 -- 头像面
        authrization_url: null, // 授权函地址
        licence_url_key: null, // 营业执照地址 - cos key
        id_card_no_url_b_key: null, // 身份证照片 -- 国徽面 - cos key
        id_card_no_url_key: null, // 身份证照片 -- 头像面 - cos key
        authrization_url_key: null, // 授权函地址 - cos key
        account_province: '',
        city_province: '',
      },
      provinceList: [],
      cityList: [],
      limitCountImg: 1, // 上传图片的最大数量
      hideUpload: false,
      hideUploadAnti: false,
      licenseHide: false,
      officialHide: false,
      getDraftRes: {},
    };
  },
  computed: {
    rules() {
      if (this.formData.step === 1) {
        return this.rules_step1;
      }
      return { ...this.rules_step1, ...this.rules_step2 };
    },
    fileMap() {
      return {
        id_card_no_url: {
          hideClass: 'hideUpload',
        },
        id_card_no_url_b: {
          hideClass: 'hideUploadAnti',
        },
        licence_url: {
          hideClass: 'licenseHide',
        },
        authrization_url: {
          hideClass: 'officialHide',
        },
      };
    },
    uploadUrl() {
      return ``;
    },
    id_card_no_url_file_list() {
      return this.formData.id_card_no_url
        ? [{ name: 'id_card_no_url', url: atob(this.formData.id_card_no_url) }]
        : [];
    },
    id_card_no_url_b_file_list() {
      return this.formData.id_card_no_url_b
        ? [
            {
              name: 'id_card_no_url_b',
              url: atob(this.formData.id_card_no_url_b),
            },
          ]
        : [];
    },
    licence_url_file_list() {
      return this.formData.licence_url
        ? [{ name: 'licence_url', url: atob(this.formData.licence_url) }]
        : [];
    },
    authrization_url_file_list() {
      return this.formData.authrization_url
        ? [
            {
              name: 'authrization_url',
              url: atob(this.formData.authrization_url),
            },
          ]
        : [];
    },
    getHeaders() {
      return {
        token: '',
      };
    },
    activeStep() {
      if (this.enterpriseInfo) {
        if (this.enterpriseInfo.status !== 'SUBMIT') {
          return 4;
        }
        return 3;
      }
      // this.formData.step = !!this.formData.step ? this.formData.step : 1;
      return this.formData.step === 1 ? 1 : 2;
    },
    enterpriseTypeName() {
      if (!this.enterpriseInfo || !this.enterpriseType) {
        return '';
      }
      const option = this.enterpriseType.find(
        (i) => i.value === this.enterpriseInfo.enterprise_type,
      );
      return option ? option.name : '';
    },
    userSizeName() {
      if (!this.enterpriseInfo || !this.userSize) {
        return '';
      }
      const option = this.userSize.find((i) => i.value === this.enterpriseInfo.user_size);
      return option ? option.name : '';
    },
  },
  async mounted() {
    await this.init();
    this.getProvince();
    if (this.formData.account_province) {
      this.citychang(this.formData.account_province);
    }
  },
  methods: {
    goBack() {
      if (this.activeStep <= 2) {
        this.$confirm('是否保存修改内容?', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            await this.saveDraft();
            this.$router.push('/p/login');
          })
          .catch(() => {
            this.$router.push('/p/login');
          });
      } else {
        this.$router.push('/p/login');
      }
    },
    goNext() {
      const formName = 'formData';
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$message.error('信息填写不完整或错误');
          return false;
        }
        if (!this.formData.agreement) {
          this.$message('请勾选平台法律同意条款');
          return;
        }
        this.formData.step = 2;
      });
    },
    goPrev() {
      this.formData.step = 1;
    },
    handleAvatarRemove(field) {
      this.formData[field] = null;
    },
    handleAvatarRemovePositive(field, fileList) {
      this.formData[field] = null;
      this.hideUpload = fileList.length >= this.limitCount;
    },
    handleAvatarRemoveAnti(field, fileList) {
      this.formData[field] = null;
      this.hideUploadAnti = fileList.length >= this.limitCount;
    },
    handleAvatarRemoveLicense(field, fileList) {
      this.formData[field] = null;
      this.licenseHide = fileList.length >= this.limitCount;
    },
    handleAvatarRemoveOfficial(field, fileList) {
      this.formData[field] = null;
      this.officialHide = fileList.length >= this.limitCount;
    },
    stepClass(step, prefix) {
      if (step == 4 && this.enterpriseInfo && this.enterpriseInfo.status == 'REJECTED') {
        return `schedule-${prefix}-failure`;
      }

      if (step < this.activeStep) {
        return `schedule-${prefix}-success`;
      }
      if (step == this.activeStep) {
        return `schedule-${prefix}`;
      }
      return `schedule-${prefix}-future`;
    },
    handleAvatarProgress(field) {
      const { hideClass } = this.fileMap[field];
      this[hideClass] = true;
      // this.hideUpload = false
      // this.formData[field] = response.ResultDate.cos_file_url.split("?")[0]
    },
    handleAvatarError(field) {
      this.$message.error('上传图像失败');
      this.formData[field] = null;

      setTimeout(() => {
        const { hideClass } = this.fileMap[field];
        this[hideClass] = false;
      }, 900);
    },
    handleAvatarSuccess(field, response) {
      this.formData[field] = btoa(response.ResultDate.cos_file_url);
      this.formData[`${field}_key`] = btoa(response.ResultDate.cos_key);
      // this.formData[field] = response.ResultDate.cos_file_url.split("?")[0]
    },
    selectImg() {},
    imageUrl() {},
    beforeAvatarUpload(field, file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是JPG/PNG格式!');
      }
      const success = isLt2M && (isJPG || isPNG);
      if (success) {
        const { hideClass } = this.fileMap[field];
        this[hideClass] = true;
      }
      return success;
    },
    // 初始化
    async init() {
      await this.getSelectOption();
      const response = (await getEnterpriseByManagers()) || {};
      let { success, info } = response;

      if (success) {
        this.enterpriseInfo = info;
        return;
      }

      this.getDraftRes = await this.getDraft();
      success = this.getDraftRes.success;
      info = this.getDraftRes.info;
      if (success) {
        info.step = info.step ? info.step : 1;
        this.formData = info;
        this.hideUpload = !!this.formData.id_card_no_url;
        this.hideUploadAnti = !!this.formData.id_card_no_url_b;
        this.licenseHide = !!this.formData.licence_url;
        this.officialHide = !!this.formData.authrization_url;
      }
    },
    async getSelectOption() {
      const req = { type: ['enterprise_type', 'user_size'] };
      const result = await selectOptions(req);
      this.enterpriseType = result.enterprise_type;
      this.userSize = result.user_size;
    },
    async saveDraft() {
      try {
        const { success } = await saveDrafts(this.formData);
        if (success) {
          this.$message('保存草稿成功');
        } else {
          this.$message('保存草稿失败');
        }
      } catch (e) {
        this.$message('保存草稿失败');
      }
    },

    async getDraft() {
      try {
        return await getDrafts();
      } catch (e) {
        return { success: false };
      }
    },
    async doSubmit(formName) {
      if (!this.formData.agreement) {
        this.$alert('请勾选平台法律同意条款', '', {
          confirmButtonText: '确定',
        });
        return;
      }
      // 验证未通过
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$message.error('信息填写不完整或错误');
          return false;
        }
        const formData = Object.assign({}, this.formData);

        delete formData.licence_url;
        delete formData.id_card_no_url_b;
        delete formData.id_card_no_url;
        delete formData.authrization_url;

        const { success, info, error } = await registerEnterprises(formData);
        if (success) {
          this.enterpriseInfo = info;
        } else {
          this.$message.error(error);
        }
      });
    },
    citychang(state) {
      if (state === '') {
        return;
      }
      const req = { provinceCode: state };
      this.$sendToEgg({ cmd: 'cityList', query: JSON.stringify(req) })
        .then((res) => {
          if (res.result.code === 40001) {
            this.$invalidToken();
            this.StrategyLoading = false;
            return;
          }
          if (res.result.code === 40006) {
            this.$message(res.result.ResultDate.msg);
            this.StrategyLoading = false;
            return;
          }
          if (res.result.code !== 0) {
            this.$message('数据信息获取失败');
            this.StrategyLoading = false;
            return;
          }
          this.cityList = res.result.cityList;
          const listnew = JSON.parse(JSON.stringify(this.cityList));
          const newlist = listnew.filter((item) => item.cityCode === this.formData.city_province);
          if (newlist.length === 0) {
            this.formData.city_province = '';
          }
          this.StrategyLoading = false;
        })
        .catch(() => {
          this.$message('查询失败');
          this.StrategyLoading = false;
        });
    },
    getProvince() {
      // this.StrategyLoading = true;
      const req = {};
      this.$sendToEgg({ cmd: 'provinceList', query: JSON.stringify(req) })
        .then((res) => {
          if (res.result.code === 40001) {
            this.$invalidToken();
            // this.StrategyLoading = false;
            return;
          }
          if (res.result.code === 40006) {
            this.$message(res.result.ResultDate.msg);
            // this.StrategyLoading = false;
            return;
          }
          if (res.result.code !== 0) {
            this.$message('数据信息获取失败');
            // this.StrategyLoading = false;
            return;
          }
          this.provinceList = res.result.provinceList;

          // this.StrategyLoading = false;
        })
        .catch(() => {
          this.$message('查询失败');
          // this.StrategyLoading = false;
        });
    },
    dealImgChange(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCountImg;
    },
    dealImgChangeAnti(file, fileList) {
      this.hideUploadAnti = fileList.length >= this.limitCountImg;
    },
    Licensechange(file, fileList) {
      this.licenseHide = fileList.length >= this.limitCountImg;
    },
    Officialchange(file, fileList) {
      this.officialHide = fileList.length >= this.limitCountImg;
    },
    // 下载授权公函
    downOfficial() {
      this.$message('开始下载授权公函');
      const downloadLink = document.createElement('a');
      downloadLink.href = IMG_SRC.authorizationDoc;
      downloadLink.download = '授权公函.docx';
      downloadLink.click();
      this.$message('下载成功');
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
